// extracted by mini-css-extract-plugin
export default {"projectContainer":"Project_projectContainer__3hWQi"};